import React, { useState, Suspense } from 'react';
import CommanToolTip from '../../components/CommanToolTip';
import Spinner from '../../components/Spinner';
import { Link } from 'react-router-dom';
import { RightArrow } from '../../assets/svg/ArrowIcon';
import { formatAmount, webFormatCurrency } from '@rb-serve-app/core';
import moment from 'moment';
import Button from '../../components/Button';
import { useSelector } from 'react-redux';

export default function TransactionTable({
  filteredActivities,
  transactions,
  openModal,
  isFirstLoad,
  eppDetails,
  assets,
  groupedActivities,
  totalAmount,
  productName,
  CardHolders,
  selectedCard,
  rb_transaction_history,
  rb_recent_transactions,
  currentUser,
  setOffset,
  totalCount,
  rb_epp,
}: any) {
  const lang = localStorage.getItem('language') || 'en-US';

  const setupLocale = () => {
    try {
      const localeToUse = lang?.includes('fr') ? 'fr' : 'en';
      moment.locale(localeToUse);
      return localeToUse;
    } catch (error) {
      console.warn('Error setting moment locale:', error);
      moment.locale('en');
      return 'en';
    }
  };

  setupLocale();
  const formatDate = (dateString: string) => moment(dateString).format('ll');
  console.log(filteredActivities?.length, 'filteredActivities', totalCount);
  console.log(
    'rb_epp --------->',
    JSON.stringify(rb_epp.eppWebConfig, null, 2)
  );

  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );
  const { entries } = contentfulData || {};
  const { rb_common, rb_transaction_details } = entries || {};

  const TableHeader = () => {
    return (
      <thead className="border-b">
        <tr>
          <th
            aria-label={rb_transaction_history.dateTitle}
            className="text-base py-2 px-4 border-b text-left text-[#666666] font-normal hidden lg:table-cell w-[15%]"
          >
            {rb_transaction_history.dateTitle}
          </th>
          <th
            aria-label={rb_transaction_history.transactionDescriptionTitle}
            className="text-base py-2 px-4 border-b text-left text-[#666666] font-normal md:w-[30%] w-[50%]"
          >
            {rb_transaction_history.transactionDescriptionTitle}
          </th>

          {selectedCard.nameOnCard === rb_common.commonString.allCardholders ? (
            <th
              aria-label={rb_transaction_history.cardholderNameTitle}
              className="text-base py-2 px-4 border-b text-left text-[#666666] font-normal w-[20%] hidden lg:table-cell"
            >
              {rb_transaction_details.transactionInfo.cardholderNameTitle ||
                'Cardholder'}
            </th>
          ) : null}

          <th
            aria-label={rb_transaction_history.transactionCategoryTitle}
            className="text-base py-2 px-4 border-b text-left text-[#666666] font-normal hidden lg:table-cell w-[15%]"
          >
            {rb_transaction_history.transactionCategoryTitle}
          </th>
          <th
            aria-label={rb_transaction_history.amountTitle}
            className="text-base py-2 px-4 border-b sm:pr-10 lg:pr-4 justify-end text-right text-[#666666] font-normal w-[12%]"
          >
            {rb_transaction_history.amountTitle}
          </th>
          <th className="text-base py-2 px-4 border-b text-[#666666] font-normal md:w-[8%] hidden">
            {/* Empty header for view button column */}
          </th>
        </tr>
      </thead>
    );
  };

  const TableSkeleton = () => (
    <div className="animate-pulse">
      <div className="h-16 bg-gray-200 mb-4 rounded"></div>
      {[...Array(5)].map((_, i) => (
        <div key={i} className="h-12 bg-gray-100 mb-2 rounded"></div>
      ))}
    </div>
  );
  const scrollToTop = () => {
    let position = window.scrollY;
    const step = 100;
    const interval = setInterval(() => {
      if (position > 0) {
        position -= step;
        window.scrollTo(0, position);
      } else {
        clearInterval(interval);
      }
    }, 5);
  };
  // console.log(
  //   'groupedActivities',
  //   filteredActivities,
  //   filteredActivities?.length === 0 || filteredActivities == null,
  //   !isFirstLoad && filteredActivities?.length == 0,
  //   isFirstLoad
  // );
  return (
    <div>
      {filteredActivities?.length > 0 && transactions?.length > 0 ? (
        <div className="mt-5">
          {eppDetails?.installData?.installmentPlans?.length > 0 && (
            <div className="flex p-6 justify-between items-center rounded-lg border border-gray-300 bg-white my-3.5">
              <div className="flex gap-[10px] items-center">
                <img
                  src={assets.epp_icon}
                  alt="eppIcon"
                  className="h-10 w-10 ml-4"
                />

                <div className="flex flex-col gap-[5px]">
                  <h3
                    aria-label={rb_transaction_history.eppTitle}
                    className="text-[#DA291C] text-[15px] font-[590] leading-[20px] md:text-[17px] md:font-[600] md:leading-[22px] tracking-[-0.07px]"
                  >
                    {rb_transaction_history.eppTitle}
                  </h3>
                  <p
                    aria-label={rb_transaction_history.viewEppSubTitle}
                    className="text-[#1F1F1F] text-[12px] font-normal md:text-[15px] md:font-[590] leading-[20px] tracking-[-0.075px]"
                  >
                    {rb_transaction_history.viewEppSubTitle}
                  </p>
                </div>
              </div>
              <Link
                to="/equal-payment-plan"
                aria-label="View Equal Payment Plan"
              >
                <p
                  aria-label={rb_transaction_history.viewEppBtn}
                  className="flex max-h-[48px] md:px-8 px-5 py-3 justify-center items-center hidden lg:block lg:border lg:border-[#DA291C] lg:bg-white lg:text-[#DA291C] lg:text-[16px] lg:font-[650] lg:leading-[20px] lg:tracking-[-0.051px]"
                >
                  {rb_transaction_history.viewEppBtn}
                </p>
                <span className="view-text block lg:hidden">
                  <RightArrow width="24px" height="24px" />
                </span>
              </Link>
            </div>
          )}
          {Object.keys(groupedActivities).length > 0 &&
            Object.keys(groupedActivities).map((activityStatus) => (
              <div key={activityStatus} className="mt-5">
                <p className="text-base text-[#1F1F1F] text-[15px] mb-2 flex flex-row">
                  {activityStatus === 'APPROVED'
                    ? rb_transaction_history?.postedTitle
                    : activityStatus === 'PENDING'
                      ? rb_transaction_history.pendingTitle
                      : rb_recent_transactions.declinedStatusTitle}
                  <CommanToolTip
                    label={''}
                    tooltipText={
                      activityStatus === 'APPROVED'
                        ? rb_transaction_history.postedTooltip
                        : activityStatus === 'PENDING'
                          ? rb_transaction_history.pendingTooltip
                          : rb_recent_transactions.declinedStatusTitle
                    }
                    isVisible={false}
                    fill="#DA291C"
                    onToggle={() => {
                      console.log('toggle changes');
                    }}
                  />
                </p>
                <div className="overflow-x-auto">
                  <Suspense fallback={<TableSkeleton />}>
                    <table className="min-w-full bg-white rounded-lg shadow-md">
                      <TableHeader />
                      <tbody>
                        {groupedActivities[activityStatus].map(
                          (transaction: any, index: any) => (
                            <tr
                              key={transaction.id || index}
                              className="group border-b"
                            >
                              <td
                                aria-label={formatDate(transaction.date)}
                                className="text-base py-2 px-4 border-b hidden lg:table-cell group-hover:bg-[#f5f5f5] text-[#1F1F1F]"
                              >
                                {formatDate(transaction.date)}
                              </td>
                              <td className="lg:py-2 px-4 py-3 lg:border-b group-hover:bg-[#f5f5f5] border-b-0">
                                <div className="flex flex-col gap-1">
                                  <span
                                    aria-label={formatDate(transaction.date)}
                                    className="block lg:hidden text-xs font-medium text-[#1F1F1F]"
                                  >
                                    {formatDate(transaction.date)}
                                  </span>
                                  <div className="flex flex-col lg:flex-row lg:items-center gap-2 lg:gap-2">
                                    <span
                                      aria-label={transaction.merchant.name?.toLowerCase()}
                                      style={{ textTransform: 'capitalize' }}
                                      className="md:text-base text-xs text-[#1F1F1F]"
                                    >
                                      {transaction.merchant.name?.toLowerCase()}
                                    </span>
                                    {/* EPP Flag - Show on mobile and desktop only */}
                                    {(transaction.eligibleforEPP ||
                                      (!transaction.eligibleforEPP &&
                                        transaction.installmentTransactionStatus ===
                                          'PLAN_CREATED')) && (
                                      <div className="w-full lg:w-auto md:hidden lg:block">
                                        {transaction.eligibleforEPP && (
                                          <span
                                            aria-label={
                                              rb_epp?.eppWebConfig
                                                ?.transactionTableEpp
                                                ?.transactionEppFlagLabel
                                            }
                                            className="inline-block px-1.5 py-0.5 text-[9px] md:text-[10px] md:px-2 md:py-1 font-medium text-[#DA291C] bg-[#FFF0F0] border border-[#DA291C] rounded-sm text-left whitespace-normal"
                                          >
                                            {rb_epp?.eppWebConfig
                                              ?.transactionTableEpp
                                              ?.transactionEppFlagLabel ||
                                              'EPP eligible'}
                                          </span>
                                        )}
                                        {!transaction.eligibleforEPP &&
                                          transaction.installmentTransactionStatus ===
                                            'PLAN_CREATED' && (
                                            <span
                                              aria-label={
                                                rb_epp?.eppWebConfig
                                                  ?.transactionTableEpp
                                                  ?.transactionEppFlagConversionLabel
                                              }
                                              className="inline-block px-1.5 py-0.5 text-[9px] md:text-[10px] md:px-2 md:py-1 font-medium text-[#1E8240] bg-[#F4FCF7] border border-[#1E8240] rounded-sm text-left whitespace-normal"
                                            >
                                              {rb_epp?.eppWebConfig
                                                ?.transactionTableEpp
                                                ?.transactionEppFlagConversionLabel ||
                                                'Enrolled in an Equal Payment Plan'}
                                            </span>
                                          )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </td>
                              {CardHolders &&
                              CardHolders.length > 1 &&
                              selectedCard.nameOnCard ===
                                rb_common.commonString.allCardholders ? (
                                <td className="py-2 px-4 border-b hidden lg:table-cell group-hover:bg-[#f5f5f5] text-[#1F1F1F] w-1/6 capitalize">
                                  {currentUser.toLowerCase() ==
                                  transaction?.name?.nameOnCard?.toLowerCase()
                                    ? ''
                                    : transaction?.name?.nameOnCard?.toLowerCase()}
                                </td>
                              ) : null}

                              <td
                                aria-label={
                                  rb_recent_transactions?.filterCategoryList[
                                    transaction.merchant.category
                                      ?.toLowerCase()
                                      .replace(/\s+/g, '_')
                                  ]
                                }
                                className="py-2 px-4 border-b hidden lg:table-cell group-hover:bg-[#f5f5f5] text-[#1F1F1F] w-1/6 capitalize"
                              >
                                {/* {transaction.merchant.category?.toLowerCase()} */}
                                {
                                  rb_recent_transactions?.filterCategoryList[
                                    transaction.merchant.category
                                      ?.toLowerCase()
                                      .replace(/\s+/g, '_')
                                  ]
                                }
                              </td>
                              <td
                                className="lg:py-2 pt-3 pb-3 lg:px-4 pl-4 pr-2 flex lg:border-b items-end lg:table-cell flex-col group-hover:bg-[#f5f5f5] relative h-full cursor-pointer lg:cursor-default border-b-0"
                                onClick={(e) => {
                                  if (window.innerWidth < 1024) {
                                    e.stopPropagation();
                                    openModal(transaction);
                                  }
                                }}
                              >
                                <div className="w-full flex flex-col items-end">
                                  <span
                                    aria-label={
                                      rb_recent_transactions
                                        ?.filterCategoryList[
                                        transaction.merchant.category
                                          ?.toLowerCase()
                                          .replace(/\s+/g, '_')
                                      ]
                                    }
                                    className="block lg:hidden text-xs md:font-medium font-light text-[#1F1F1F] text-right pr-8"
                                  >
                                    {
                                      rb_recent_transactions
                                        ?.filterCategoryList[
                                        transaction.merchant.category
                                          ?.toLowerCase()
                                          .replace(/\s+/g, '_')
                                      ]
                                    }
                                  </span>
                                  {/* EPP Flag for tablet portrait only - below category */}
                                  {(transaction.eligibleforEPP ||
                                    (!transaction.eligibleforEPP &&
                                      transaction.installmentTransactionStatus ===
                                        'PLAN_CREATED')) && (
                                    <div className="hidden md:flex lg:hidden justify-end pr-8 mt-1 w-full">
                                      {transaction.eligibleforEPP && (
                                        <span
                                          aria-label={
                                            rb_epp?.eppWebConfig
                                              ?.transactionTableEpp
                                              ?.transactionEppFlagLabel
                                          }
                                          className="inline-block px-1.5 py-0.5 text-[9px] md:text-[10px] md:px-2 md:py-1 font-medium text-[#DA291C] bg-[#FFF0F0] border border-[#DA291C] rounded-sm text-left whitespace-nowrap"
                                        >
                                          {rb_epp?.eppWebConfig
                                            ?.transactionTableEpp
                                            ?.transactionEppFlagLabel ||
                                            'EPP eligible'}
                                        </span>
                                      )}
                                      {!transaction.eligibleforEPP &&
                                        transaction.installmentTransactionStatus ===
                                          'PLAN_CREATED' && (
                                          <span
                                            aria-label={
                                              rb_epp?.eppWebConfig
                                                ?.transactionTableEpp
                                                ?.transactionEppFlagConversionLabel
                                            }
                                            className="inline-block px-1.5 py-0.5 text-[9px] md:text-[10px] md:px-2 md:py-1 font-medium text-[#1E8240] bg-[#F4FCF7] border border-[#1E8240] rounded-sm text-left whitespace-nowrap"
                                          >
                                            {rb_epp?.eppWebConfig
                                              ?.transactionTableEpp
                                              ?.transactionEppFlagConversionLabel ||
                                              'Enrolled in an Equal Payment Plan'}
                                          </span>
                                        )}
                                    </div>
                                  )}
                                  <span className="md:text-base text-xs text-[#1F1F1F] pr-8 lg:pr-0">
                                    {transaction.foreign ? (
                                      <div className="flex flex-row relative justify-end">
                                        <span className="material-icons relative top-1 mr-1">
                                          <img
                                            src={assets?.fx_logo}
                                            alt="foreign transaction"
                                            className="w-5 h-5"
                                          />
                                        </span>

                                        <span
                                          aria-label={transaction?.amount.value}
                                        >
                                          {Number(transaction.amount.value) < 0
                                            ? `-${webFormatCurrency(Math.abs(Number(transaction?.amount.value)), lang)}`
                                            : `${webFormatCurrency(Number(transaction?.amount.value), lang)}`}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="flex flex-row justify-end">
                                        <span
                                          className=""
                                          aria-label={transaction?.amount.value}
                                        >
                                          {Number(transaction.amount.value) < 0
                                            ? `-${webFormatCurrency(Math.abs(Number(transaction?.amount.value)), lang)}`
                                            : `${webFormatCurrency(Number(transaction?.amount.value), lang)}`}
                                        </span>
                                      </div>
                                    )}
                                  </span>
                                </div>
                                <span className="view-text absolute lg:hidden right-4 top-1/2 -translate-y-1/2">
                                  <RightArrow width="24px" height="24px" />
                                </span>
                              </td>
                              <td
                                className="py-2 lg:pr-4 pr-2 border-b items-center lg:items-end lg:table-cell flex-col group-hover:bg-[#f5f5f5] relative cursor-pointer hidden lg:flex"
                                onClick={() => openModal(transaction)}
                              >
                                <a
                                  aria-label={rb_transaction_history.viewTitle}
                                  className={`view-text absolute tablet:hidden hidden md:block  top-2 bottom-0 mr-6 text-[#DA291C] underline opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-in-out ${selectedCard.nameOnCard === rb_common.commonString.allCardholders ? 'right-0' : 'right-[50%]'}`}
                                >
                                  {rb_transaction_history.viewTitle}
                                </a>
                              </td>
                            </tr>
                          )
                        )}

                        {activityStatus !== 'APPROVED' && (
                          <tr className="font-bold bg-[#F5F5F5]">
                            <td
                              aria-label={rb_transaction_history.totalTitle}
                              className="md:text-base text-xs py-2 px-4 hidden lg:table-cell"
                            >
                              {rb_transaction_history.totalTitle}
                            </td>
                            <td className="py-2 px-4">
                              <span
                                aria-label={rb_transaction_history.totalTitle}
                                className="block lg:hidden text-xs font-medium"
                              >
                                {rb_transaction_history.totalTitle}
                              </span>
                            </td>
                            <td className="py-2 px-4 hidden lg:table-cell"></td>
                            <td
                              className={
                                selectedCard.nameOnCard !==
                                  rb_common.commonString.allCardholders ||
                                !selectedCard
                                  ? `flex flex-row md:text-base pl-10 text-xs py-2 lg:pr-4 pr-10 ipad-landscape:text-left justify-end`
                                  : `py-2 px-4 hidden lg:table-cell`
                              }
                            >
                              {selectedCard.nameOnCard !==
                                rb_common.commonString.allCardholders && (
                                <>
                                  {Number(totalAmount[activityStatus]) < 0
                                    ? `-${webFormatCurrency(
                                        Math.abs(
                                          Number(
                                            totalAmount[
                                              activityStatus
                                            ]?.toFixed(2)
                                          )
                                        ),
                                        lang
                                      )}`
                                    : `${webFormatCurrency(Number(totalAmount[activityStatus]?.toFixed(2)), lang)}`}
                                </>
                              )}
                            </td>
                            {CardHolders &&
                            CardHolders.length > 1 &&
                            selectedCard.nameOnCard ===
                              rb_common.commonString.allCardholders ? (
                              <td
                                className={
                                  selectedCard.nameOnCard ==
                                  rb_common.commonString.allCardholders
                                    ? `flex flex-row md:text-base pl-10 text-xs py-2 lg:pr-4 pr-10 ipad-landscape:text-left justify-end`
                                    : `py-2 px-4 hidden lg:table-cell`
                                }
                              >
                                {Number(totalAmount[activityStatus]) < 0 &&
                                selectedCard.nameOnCard ==
                                  rb_common.commonString.allCardholders
                                  ? `-${webFormatCurrency(
                                      Math.abs(
                                        Number(
                                          totalAmount[activityStatus]?.toFixed(
                                            2
                                          )
                                        )
                                      ),
                                      lang
                                    )}`
                                  : selectedCard.nameOnCard ==
                                      rb_common.commonString.allCardholders &&
                                    `${webFormatCurrency(Number(totalAmount[activityStatus]?.toFixed(2)), lang)}`}
                              </td>
                            ) : null}
                            <td className="py-2 px-4 hidden lg:table-cell"></td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </Suspense>
                </div>
              </div>
            ))}
          <div
            className={`flex flex-col items-center justify-center ${transactions.length < totalCount && 'mt-[30px]'}`}
          >
            {transactions.length < totalCount && (
              <Button
                variant={'secondary'}
                onClick={() => {
                  setOffset((prev: number) => prev + 1);
                  setTimeout(() => {
                    window.scrollTo({
                      top: document.documentElement.scrollHeight,
                      behavior: 'smooth',
                    });
                  }, 300);
                }}
                aria-label={
                  rb_transaction_history?.transactionsFilter
                    ?.accessibility_showMoreCta_text
                }
                className="text-[16px] font-medium py-2 px-4"
              >
                <span className="text-[16px]" aria-hidden="true">
                  {rb_transaction_history?.transactionsFilter?.showMoreCta}
                </span>
              </Button>
            )}
            <p
              role="button" // Add role for better accessibility
              tabIndex={0} // Allow keyboard focus
              onClick={() => {
                if (transactions.length < totalCount) {
                  scrollToTop();
                }
              }}
              onKeyDown={(e) => {
                // Support keyboard activation
                if (e.key === 'Enter' || e.key === ' ') {
                  if (transactions.length < totalCount) {
                    scrollToTop();
                  }
                }
              }}
              className={`${
                transactions.length < totalCount
                  ? 'text-primary-red hover:underline cursor-pointer'
                  : 'text-[#666]'
              } mt-[15px] font-[450] text-[16px] text-center`}
              aria-label={
                transactions.length < totalCount
                  ? rb_transaction_history?.transactionsFilter?.goTopCta ||
                    'Go to top'
                  : rb_transaction_history?.transactionsFilter
                      ?.no_more_transaction || 'No more transactions'
              }
            >
              {transactions.length < totalCount
                ? rb_transaction_history?.transactionsFilter?.goTopCta ||
                  'Go to top'
                : rb_transaction_history?.transactionsFilter
                    ?.no_more_transaction || 'No more transactions'}
            </p>
          </div>
        </div>
      ) : (!isFirstLoad &&
          Object.keys(groupedActivities).length === 0 &&
          totalCount == null) ||
        (!isFirstLoad &&
          filteredActivities?.length == 0 &&
          totalCount == null) ||
        (!isFirstLoad && filteredActivities?.length == 0) ? (
        <div
          className="flex items-center justify-center h-full w-full flex-col"
          data-testid="no-data-found"
        >
          <img
            src={assets.no_transaction_logo}
            alt="NoTransactionIcon"
            className="h-[281px] w-[376px]"
          />
          <p aria-label={rb_transaction_history.noTransactionsTitle}>
            {rb_transaction_history.noTransactionsTitle}
          </p>
        </div>
      ) : (
        <div
          className="h-[50%] w-full flex justify-center mt-10"
          data-testid="spinner-container"
          role="status"
        >
          <Spinner />
        </div>
      )}
    </div>
  );
}
